/* ============================================================
   BARRA DEL TELEFONO CON LA FOTO AL CENTRO (04/10/2026)
   Disegna una forma sola: il rettangolo stondato della barra piu'
   la cupola intorno al tondo della foto, raccordata con due curve
   morbide. La stessa forma ritaglia il vetro e fa da bordo.
   Si misura sul tondo vero, quindi segue da sola la barra quando
   scorrendo si stringe.
   ============================================================ */
(function(){
  const barra = document.querySelector('.barra-basso--centro');
  if(!barra) return;
  const fondo = barra.querySelector('.barra-basso__fondo');
  const vetro = fondo.querySelector('i');
  const linea = fondo.querySelector('path');
  const tondo = barra.querySelector('.voce-basso--io .avatar');

  /* la foto scelta nella pagina Il mio account: per ora sta nel browser */
  try {
    const foto = localStorage.getItem('bulier-foto');
    if(foto){ tondo.style.backgroundImage = `url("${foto}")`; tondo.classList.add('ha-foto'); }
  } catch(e){}

  function forma(){
    const b = barra.getBoundingClientRect(), t = tondo.getBoundingClientRect();
    if(!b.width) return;
    const rb = t.width/2 + 7;                       /* la cupola: tondo + respiro */
    const su = Math.max(0, b.top - (t.top - 7));    /* quanto sporge sopra la barra */
    const W = b.width, Hb = b.height, T = Hb + su;
    const R = parseFloat(getComputedStyle(barra).borderTopLeftRadius) || 24;
    const cx = t.left + t.width/2 - b.left, cy = rb;          /* centro cupola, dall'alto */
    const f = 10;                                             /* raccordo */
    const dy = cy - (su - f), dx = Math.sqrt(Math.max(0, (rb+f)**2 - dy**2));
    const k = rb/(rb+f);
    const p1 = [cx - dx*k, cy + (su - f - cy)*k];       /* punto sulla cupola, sinistra */
    const p2 = [cx + dx*k, p1[1]];
    const grande = p1[1] > cy ? 1 : 0;
    const d = `M${R},${su} L${cx-dx},${su} A${f},${f} 0 0 0 ${p1[0]},${p1[1]}`
      + ` A${rb},${rb} 0 ${grande} 1 ${p2[0]},${p2[1]} A${f},${f} 0 0 0 ${cx+dx},${su}`
      + ` L${W-R},${su} A${R},${R} 0 0 1 ${W},${su+R} L${W},${T-R} A${R},${R} 0 0 1 ${W-R},${T}`
      + ` L${R},${T} A${R},${R} 0 0 1 0,${T-R} L0,${su+R} A${R},${R} 0 0 1 ${R},${su} Z`;
    fondo.style.top = (-su) + 'px';
    vetro.style.clipPath = `path("${d}")`;
    linea.setAttribute('d', d);
  }
  forma();
  new ResizeObserver(forma).observe(barra);
  new ResizeObserver(forma).observe(tondo);
  /* durante il restringimento le misure cambiano a ogni fotogramma */
  let corre = false;
  barra.addEventListener('transitionrun', () => {
    if(corre) return; corre = true;
    const giro = () => { forma(); if(corre) requestAnimationFrame(giro); };
    giro();
  });
  barra.addEventListener('transitionend', () => { corre = false; forma(); });
  addEventListener('resize', forma);
})();
